import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpousalWaiverAttachment } from '../../../../models/submissions/spousal-waiver-attachment';
import { TrackByUtils } from '../../../../utils/track-by-utils';
import { SpousalWaiverTypeLabelPipe } from '../../pipes/spousal-waiver-type-label.pipe';
import { FileListItemComponent } from '../../../../ui/file-list-item/file-list-item.component';
import { AttachmentLinkPipe } from '../../../../pipes/attachment-link.pipe';
import { ReviewEntryComponent } from '../../../../ui/review-components/review-entry/review-entry.component';

@Component({
  selector: 'app-submission-details-spousal-waiver-card',
  standalone: true,
  imports: [CommonModule, SpousalWaiverTypeLabelPipe, FileListItemComponent, AttachmentLinkPipe, ReviewEntryComponent],
  templateUrl: './submission-details-spousal-waiver-card.component.html',
  styleUrls: ['./submission-details-spousal-waiver-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmissionDetailsSpousalWaiverCardComponent {
  @Input({ required: true }) cardTitle!: string;
  @Input() waivers: SpousalWaiverAttachment[] = [];

  public trackById = TrackByUtils.trackById;
}
